// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HEg9","content":"styles_content__2t18s","tableWrap":"styles_tableWrap__2h_Ng"};